module.exports = __webpack_public_path__ + "partylineManage/img/reset.07927cd1.svg";